/**
 * Created by Yalovich on 27/09/2017.
 */

export abstract class AudioRepository {
  downloadAudioFile: (url: string) => Promise<string>;

  getAudioURL: (audioId: number) => Promise<any>;
}
